import {flatten} from 'flat';
import {mergeWith, transform} from 'lodash';

import {DEFAULT_LANGUAGE} from 'constants/language';

import {delimiter} from './constants';
import languages from './languages';

const languageTranslations = transform(languages, (acc, {name, translation}) => {
    acc[name] = flatten(translation, {delimiter});
}, {});

const defaultTranslations = languageTranslations[DEFAULT_LANGUAGE];

const mergeCustomizer = (objValue, srcValue) => {
    if (srcValue === '') {
        return objValue;
    }
};
const mergeWithDefaultTranslations = (translations) => translations === defaultTranslations ? translations :
    mergeWith({}, defaultTranslations, translations, mergeCustomizer);

export const resources = transform(languageTranslations, (acc, translations, lang) => {
    acc[lang] = {translation: mergeWithDefaultTranslations(translations)};
}, {});
